import React from 'react';
import { Field, EditView } from '@builtbypixel/nucleus';

import setup from './setup';
import {Box, Container} from "@chakra-ui/react";

const EditForm = () => {
  return (
    <EditView setup={setup} isFullWidth={false}>
      <Container
          p={{ base: '10px', sm: '15px' }}
          w='100%'
          variant='card'
          rounded='none'
          maxWidth='none'
      >
        <Box display='flex' flexDir='row' gridGap='3'>
            <Field auto isFullWidth name="featured" component="switch" label="Featured" />
            <Field auto isFullWidth name="order" component="number" label="Order" />
        </Box>
          <Box display='flex' flexDir='row' gridGap='3'>
              <Field auto isFullWidth name="name" component="text" label="Name" />
              <Field auto isFullWidth name="slug" component="text" label="URL" />
          </Box>

          <Field auto isFullWidth name="description" component="richtext" label="Description" />
          <Field auto isFullWidth name="summary" component="richtext" label="Summary" />
          <Field auto isFullWidth name="page_description" component="richtext" label="Page Description" />
          <Field auto isFullWidth name="banner_image" component="file" label="Banner Image" />
      </Container>
    </EditView>
  );
};

export default EditForm;
